<!--
 * File: backups-list.component.html                                           *
 * Project: catalog-cloud                                                      *
 * File Created: Thursday, 16th June 2022 13:17:29                             *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Wednesday, 1st March 2023 14:52:33                           *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 -->

<p-card>
  <div>
    <div class="cc-page-header">
      <div class="cc-page-header-title">
        <i class="pi pi-database"></i>
        <span>{{ 'BACKUPS.TITLE' | translate }}</span>
      </div>
      <div class="cc-page-header-actions">
        <p-button styleClass="p-button-sm" icon="pi pi-plus" [label]="'BACKUPS.CREATE' | translate" (onClick)="create()"></p-button>
      </div>
    </div>
    <p-table [value]="data">
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>Auto</th>
          <th>{{"BACKUPS.NAME" | translate}}</th>
          <th>{{"BACKUPS.CREATED_AT" | translate}}</th>
          <th>{{"BACKUPS.SIZE" | translate}}</th>
          <th>Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-backup>
        <tr>
          <td>{{backup.id}}</td>
          <td>
            <i [ngClass]="{'fa fa-check': backup.auto, 'fa-solid fa-xmark': !backup.auto}"></i>
          </td>
          <td>{{backup.name}}</td>
          <td>{{backup.createdAt | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
          <td>{{backup.size | formatFileSize}}</td>
          <td>
            <p-button
              styleClass="p-button-sm"
              icon="pi pi-download"
              [rounded]="true"
              [text]="true"
              pTooltip="{{'BACKUPS.DOWNLOAD' | translate}}"
              (onClick)="download(backup.id)"
            ></p-button>
            <p-button
              styleClass="p-button-sm"
              icon="pi pi-refresh"
              [rounded]="true"
              [text]="true"
              pTooltip="{{'BACKUPS.RESTORE' | translate}}"
              (onClick)="confirmRestore(backup.id)"
            ></p-button>
            <p-button
              styleClass="p-button-sm"
              icon="pi pi-trash"
              [rounded]="true"
              [text]="true"
              pTooltip="{{'BACKUPS.DELETE' | translate}}"
              (onClick)="confirmDelete(backup.id)">
            </p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-confirmDialog
      key="confirmRestoreBackup"
      key="confirmDeleteBackup"
    ></p-confirmDialog>
    <p-messages></p-messages>
  </div>
</p-card>
